export const LOAD_TIME = 250
